import { Component, h } from 'preact';
import Modal from './generics/Modal';
import modalContent from '../constants/modalContent';
import SignInContent from './SignInContent';
import SignUpContent from './SignUpContent';
import ForgotPinContent from './ForgotPinContent';
import EmailSentContent from './EmailSentContent';

export default class SignInModal extends Component {
  constructor () {
    super();
    this.state = {
      modalContent: modalContent.SIGN_IN,
    };
  }

  componentDidMount () {
    this.setState({ modalContent: modalContent.SIGN_IN });
  }

  getModalElements () {
    const { session, mixpanelTracker } = this.props;
    const { modalContent: currentModalContent } = this.state;

    const props = {
      onChangeContent: newModalContent => this.setState({ modalContent: newModalContent }),
      session,
      mixpanelTracker,
    };

    switch (currentModalContent) {
      case modalContent.SIGN_IN:
        return {
          title: 'Ingresa como usuario de Primera o Siempre Plus',
          content: <SignInContent {...props} />,
        };
      case modalContent.SIGN_UP:
        return {
          title: 'Inicia el proceso para acumular kms',
          content: <SignUpContent {...props} />,
        };
      case modalContent.FORGOT_PIN:
        return {
          title: 'Recuperar contraseña',
          content: <ForgotPinContent {...props} />,
        };
      case modalContent.EMAIL_SENT:
        return {
          title: 'Recuperar contraseña',
          content: <EmailSentContent {...props} />,
        };
      default:
        return null;
    }
  }

  render ({ onClose }) {
    const elements = this.getModalElements();

    return (
      <Modal title={elements.title} onUserClose={onClose}>
        {elements.content}
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./components/SignInModal.js